export default function goBack() {
    const goBackButtons = document.querySelectorAll(".go-back-button[data-go-back]");

    if (goBackButtons) {
        goBackButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                history.back();
            });
        });
    }
}
